import {
    UPDATE,
    BULK_UPDATE,
    LOAD,
    SAVE,
    DIRTY
} from '@/store/actions/edit_ride/ride';
import { CREATE } from '@/store/actions/edit_ride';
import { types as WAYPOINT_TYPES } from '@/store/actions/edit_ride/waypoints';
import { TOGGLE as OPTIONS_TOGGLE } from '@/store/actions/edit_ride/options';
import { SET_CONFIRM, SHOW_SAVE_MODAL } from '@/store/actions/edit_ride/meta';
import { status } from '@/helpers/async';

// data not stored on the backend
const initialState = {
    // Are there unsaved changes?
    dirty: false,
    // Are we currently saving
    saving: false,
    // Is this saved to the backend
    persisted: false,
    // Mode for confirm modal
    confirm: '', // logout, back
    // Show save modal
    saveModal: false
};

const isWaypointType = (type) => (WAYPOINT_TYPES.includes(type) ? type : !type);

export default (state = initialState, action) => {

    switch (action.type) {
        case CREATE:
        case UPDATE:
        case BULK_UPDATE:
        case OPTIONS_TOGGLE:
        case isWaypointType(action.type): {
            return { ...state, dirty: action.data.field === 'DIRTY_VALUE' ? action.data.value : true, persisted: false };
        }

        case LOAD: {
            const rideExists = !!action.data.ride.id;
            return {
                ...initialState,
                persisted: rideExists,
                dirty: !rideExists
            };
        }

        case SAVE:
            return {
                ...state,
                saving: action.status === status.REQUEST,
                dirty: action.status !== status.SUCCESS,
                persisted: true
            };

        // undo causes issues when a ride is modified and saved
        // this is called to set previous rides to dirty when a
        // future ride has been saved and changes are undone
        case DIRTY:
            return {
                ...state,
                saving: false,
                dirty: true,
                persisted: false
            };

        case SET_CONFIRM: {
            return {
                ...state,
                confirm: action.value
            };
        }

        case SHOW_SAVE_MODAL: {
            return {
                ...state,
                saveModal: action.value
            };
        }

        default:
            return state;
    }
};
